import React, { useEffect, useState } from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import "./storeDetail/storeDetail.css";
import { Button, Grid } from "@mui/material";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import CustomizeSwitch from "../../../components/switch/customizeSwitch";
import FileUploader from "../../../components/dropzone/FileUploader";
import { toast } from "react-toastify";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useMutation } from "react-query";
import {
  AddBanner,
  AddLogo,
  AddOrUpdateCategory,
  AddStore,
  DeleteBanner,
  DeleteCategory,
  DeleteLogo,
  EditStore,
  GetCategoriesByStoreId,
  GetStore,
} from "../../../services/store.service";
import { ApiResultModel } from "../../../models/common.model";
import {
  AddLogoRequest,
  AddOrUpdateCategoryRequest,
  AddOrUpdateCategoryResponse,
  AddStoreRequest,
  DeleteLogoRequest,
  EditStoreRequest,
  GetCategoriesByStoreIdResponse,
  GetStoreResponse,
  StoreCategorie,
} from "../../../models/store.model";
import { DocumentUrl } from "../../../models/cartable.model";
import LoadDocumentCmp from "../../../components/thumbnail/loadDocumentCmp";
import { getCategoriesResponse } from "../../../models/dropdown.model";
import { getCategories } from "../../../services/dropdown.service";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import StoreCard from "../../../components/cards/storeCard";
import CheckboxImage from "../../../components/checkbox/checkboxImage";
import {
  editWalletTypeOfAStore,
  getWalletTypes,
} from "../../../services/wallet.service";
import { GetWalletTypesResponse } from "../../../models/wallet.model";
import * as Yup from "yup";
import { title } from "process";
import { useHistory } from "react-router-dom";
import { STOREID } from "../../../config/cacheKey";
import { from } from "stylis";
import ImageEditorCmp from "../../../components/dropzone/ImageEditorCmp";
import ModalCancel from "../../../components/modals/ModalCancel";

interface Category {
  categoryId: number;
  storeCategoryId?: number;
  title: string;
  icon: string;
  SettlementPercentage: number;
}

export default function CreateStore() {
  const [maxSizeKB, setMaxSizeKB] = useState<number>();
  const [isCheckedWallet, setIsCheckedWallet] = useState<boolean>();
  const [fileExtensions, setFileExtensions] = useState<string[]>([]);
  const [itemGroups, setItemGroups] = React.useState<getCategoriesResponse[]>(
    []
  );
  const [valueTitle, setValueTitle] = useState<string>();
  const [valueCategoryId, setValueCategoryId] = useState<string>();
  const [arrayCategory, setArrayCategory] = useState<any[]>([]);
  const [updateCategory, setUpdateCategory] = useState<any[]>([]);
  const [valueSettlementPercentage, setValueSettlementPercentage] = useState<
    any
  >("");
  const [valueSortIndex, setValueSortIndex] = useState<any>("");
  const [valueIsActive, setValueIsActive] = useState<boolean>(true);
  const [valueDescription, setValueDescription] = useState<any>("");
  const [walletType, setWalletType] = useState<GetWalletTypesResponse[]>([]);
  const [arrayCard, setArrayCard] = React.useState<number>();
  const [arrayCardList, setArrayCardList] = React.useState<number[]>([]);
  const [storeId, setStoreId] = React.useState<number>();
  const [storeCategory, setStoreCategory] = React.useState<number>();
  let storeCategoryId: number;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const history = useHistory<{ from: string }>();
  const [
    valueSettlementDeadlineDays,
    setValueSettlementDeadlineDays,
  ] = useState<any>("");
  const [
    valueCategoriesSettlementPercentage,
    setValueCategoriesSettlementPercentage,
  ] = useState<any>();
  const { mutateAsync: AddLogoMutate } = useMutation(AddLogo, {
    onSuccess: (data: boolean) => {
      if (data === true) {
        toast.success("ثبت اطلاعات با موفقیت انجام شد.");
      }
    },
  });
  const { mutateAsync: AddBannerMutate } = useMutation(AddBanner, {
    onSuccess: (data: boolean) => {
      if (data === true) {
        toast.success("ثبت اطلاعات با موفقیت انجام شد.");
      }
    },
  });
  const { mutateAsync: EditStoreMutate } = useMutation(EditStore, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data.isSuccess === true) {
        toast.success("ثبت اطلاعات با موفقیت انجام شد.");
        history.push("/store/storesTable");
      }
    },
  });
  const { mutateAsync: AddStoreMutate } = useMutation(AddStore, {
    onSuccess: (data: boolean) => {
      if (data === true) {
        toast.success("ثبت اطلاعات با موفقیت انجام شد.");
        history.push("/store/storesTable");
      }
    },
  });
  const { mutateAsync: GetStoreMutate } = useMutation(GetStore, {
    onSuccess: (data: ApiResultModel<GetStoreResponse>) => {
      if (data.data) {
        setDocumentLogo(data.data.logo!);
        setDocumentBanner(data.data.banner!);
        setValueTitle(data.data.title);
        setValueSettlementPercentage(data.data.settlementPercentage);
        setValueSettlementDeadlineDays(data.data.settlementDeadlineDays);
        setValueSortIndex(data.data.sortIndex);
        setValueIsActive(data.data.isActive);
        setValueDescription(data.data.description);
        const newCategories = data.data.storeCategories.map((item: any) => ({
          categoryId: parseInt(item.categoryId),
          storeCategoryId: parseInt(item.storeCategoryId),
          title: item.name,
          icon: item.icon,
          SettlementPercentage: item.settlementPercentage,
        }));
        setArrayCategory(newCategories);
        setArrayCardList(
          data.data.walletTypeIds ? data.data.walletTypeIds : []
        );
        localStorage.setItem(STOREID, "");
      }
    },
  });
  const { mutateAsync: GetCategories } = useMutation(getCategories, {
    onSuccess: (data: ApiResultModel<getCategoriesResponse[]>) => {
      setItemGroups(data.data);
    },
  });
  const { mutateAsync: GetWalletTypes } = useMutation(getWalletTypes, {
    onSuccess: (data: ApiResultModel<GetWalletTypesResponse[]>) => {
      setWalletType(data.data);
    },
  });
  const { mutateAsync: GetCategoriesByStoreIdMutation } = useMutation(
    GetCategoriesByStoreId,
    {
      onSuccess: (data: ApiResultModel<GetCategoriesByStoreIdResponse[]>) => {
        if (data.data.length > 0) {
          let categoryArray: Category[] = [];
          data.data.map((item: any) => {
            setArrayCategory([]);
            const newCategory: Category = {
              categoryId: parseInt(item.categoryId),
              storeCategoryId: parseInt(item.storeCategoryId),
              title: item.categoryTitle,
              icon: item.categoryLogoBase64,
              SettlementPercentage: item.settlementPercentage,
            };
            categoryArray.push(newCategory);
          });
          setArrayCategory(categoryArray);
        } else {
          setArrayCategory([]);
        }
      },
    }
  );

  const { mutateAsync: AddOrUpdateCategoryMutate } = useMutation(
    AddOrUpdateCategory,
    {
      onSuccess: (data: ApiResultModel<AddOrUpdateCategoryResponse>) => {
        if (data.data !== undefined) {
          GetCategoriesByStoreIdMutation({ storeId: storeId! });
          toast.success("ثبت اطلاعات با موفقیت انجام شد.");
          // setArrayCategory([...arrayCategory, newCategory]);
          setValueCategoryId(undefined);
          setValueCategoriesSettlementPercentage(undefined);
        }
      },
    }
  );
  const { mutateAsync: DeleteCategoryMutate } = useMutation(DeleteCategory, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data.data === true) {
        GetCategoriesByStoreIdMutation({ storeId: storeId! });
        // let value = arrayCategory.filter((item) => item.id !== storeCategoryId);
        // setArrayCategory(value);
      }
    },
  });

  const [attachmentDocumentLogo, setAttachmentDocumentLogo] = useState<
    DocumentUrl
  >();
  const [documentLogo, setDocumentLogo] = useState("");
  const [attachmentDocumentBanner, setAttachmentDocumentBanner] = useState<
    DocumentUrl
  >();
  const [documentBanner, setDocumentBanner] = useState("");
  const [getValueCtegory, setGetValueCtegory] = useState<
    getCategoriesResponse | undefined
  >();
  useEffect(() => {
    const from = history.location?.state?.from;
    if (from !== "store" || from === undefined) {
      const request = localStorage.getItem(STOREID);
      if (request !== null && request !== undefined && request !== "") {
        setStoreId(parseInt(request));
        GetStoreMutate({ storeId: parseInt(request), isEdit: true });
      }
    }
    GetCategories();
    GetWalletTypes();
  }, []);
  useEffect(() => {
    if (arrayCard !== undefined && arrayCard !== null) {
      if (isCheckedWallet === true) {
        setArrayCardList([...arrayCardList, arrayCard!]);
      } else {
        let value = arrayCardList.filter((item) => item !== arrayCard);
        setArrayCardList(value);
      }
    }
  }, [arrayCard, isCheckedWallet]);

  function handleChoosedImage(image: any, from: string) {
    let maxSize = maxSizeKB! * 1024;
    if (maxSize === undefined) {
      maxSize = 1024 * 1000;
    }

    if (image.data.size != null && image.data.size > maxSize) {
      toast.error(" سایز فایل مورد نظر بیشتر از اندازه مجاز است.");
      return;
    }
    // else if (fileExtensions?.includes(image.data.type)) {
    let fileUrlObj = {} as DocumentUrl;
    fileUrlObj.fileData = image.data;
    fileUrlObj.fileUrl = image.dataurl;
    fileUrlObj.fileName = image.data.name;
    fileUrlObj.fileType = image.data.type;
    if (from === "logo") {
      setAttachmentDocumentLogo(fileUrlObj);
    } else if (from === "baner") {
      setAttachmentDocumentBanner(fileUrlObj);
    }
    if (storeId !== undefined && from === "logo") {
      const uploadImageObj = {} as AddLogoRequest;
      uploadImageObj.storeId = storeId;
      uploadImageObj.file = fileUrlObj;
      AddLogoMutate(uploadImageObj);
    }
    if (storeId !== undefined && from === "baner") {
      const uploadImageObj = {} as AddLogoRequest;
      uploadImageObj.storeId = storeId;
      uploadImageObj.file = fileUrlObj;
      AddBannerMutate(uploadImageObj);
    }

    // } else {
    //   toast.warning("نوع فایل بارگذاری شده مجاز نمی باشد");
    // }
  }

  const handleSelectedProductGroup = (e: any, value: any) => {
    setValueCategoryId(e.target.value);
    let valueCategory = itemGroups.filter(
      (item: any) => item.id === e.target.value
    );
    setGetValueCtegory(valueCategory[0]);
  };

  function changeValueTitle(e: any) {
    setValueTitle(e.currentTarget.value);
  }
  function changeValueSettlementPercentage(e: any) {
    if (e.currentTarget.value <= 99) {
      setValueSettlementPercentage(e.currentTarget.value);
    }
  }
  function changeValueSettlementDeadlineDays(e: any) {
    setValueSettlementDeadlineDays(e.currentTarget.value);
  }
  function changeValueSortIndex(e: any) {
    setValueSortIndex(e.currentTarget.value);
  }
  function changeValuesetDescription(e: any) {
    setValueDescription(e.currentTarget.value);
  }
  function changeValueCategoriesSettlementPercentage(e: any) {
    if (e.currentTarget.value <= 99) {
      setValueCategoriesSettlementPercentage(e.currentTarget.value);
    }
  }
  const setChildValueLogo = (childValues: any) => {
    setAttachmentDocumentLogo(childValues);
    setDocumentLogo(childValues);
  };
  const setChildValueBaner = (childValues: any) => {
    setAttachmentDocumentBanner(childValues);
    setDocumentBanner(childValues);
  };
  const setChildeValueCategory = (childValues: any) => {
    if (storeId !== undefined) {
      storeCategoryId = childValues.storeCategoryId;
      setStoreCategory(childValues.storeCategoryId);
      setOpenModal(!openModal);
    } else {
      let value = arrayCategory.filter(
        (item) => item.categoryId !== childValues.categoryId
      );
      setArrayCategory(value);
    }
  };
  const setUpdatePercentage = (value: any) => {
    if (storeId !== undefined) {
      const addOrUpdateCategoryObj = {} as AddOrUpdateCategoryRequest;
      addOrUpdateCategoryObj.storeId = storeId!;
      addOrUpdateCategoryObj.categoryId = value.categoryId;
      addOrUpdateCategoryObj.settlementPercentage = value.SettlementPercentage;
      AddOrUpdateCategoryMutate(addOrUpdateCategoryObj);
    }
  };
  const saveCategory = () => {
    setUpdateCategory([]);
    const newCategory: Category = {
      categoryId: parseInt(valueCategoryId!),
      title: getValueCtegory?.title!,
      icon: getValueCtegory?.additionalData!,
      SettlementPercentage: valueCategoriesSettlementPercentage!,
    };
    if (storeId !== undefined) {
      const addOrUpdateCategoryObj = {} as AddOrUpdateCategoryRequest;
      addOrUpdateCategoryObj.storeId = storeId;
      addOrUpdateCategoryObj.categoryId = parseInt(valueCategoryId!);
      addOrUpdateCategoryObj.settlementPercentage = valueCategoriesSettlementPercentage!;
      AddOrUpdateCategoryMutate(addOrUpdateCategoryObj);
    } else {
      let find = arrayCategory.filter(
        (item) => item.categoryId === parseInt(valueCategoryId!)
      );
      if (find.length > 0) {
        find[0].SettlementPercentage = valueCategoriesSettlementPercentage!;
        setArrayCategory([...arrayCategory]);
        setUpdateCategory([...arrayCategory]);
      }
      if (find.length === 0) {
        setArrayCategory([...arrayCategory, newCategory]);
        setValueCategoryId("");
        setValueCategoriesSettlementPercentage(undefined);
      } else {
        setValueCategoryId("");
        setValueCategoriesSettlementPercentage(undefined);
      }
    }
  };
  const handleClose = () => {
    history.push("/store/storesTable");
  };
  const deleteImage = () => {
    DeleteCategoryMutate({ storeCategoryId: storeCategory! });
  };
  return (
    <>
      <div style={{ height: "85svh" }}>
        <DivisionCmp
          child={
            <>
              <Formik
                initialValues={{} as AddStoreRequest}
                onSubmit={(values: AddStoreRequest) => {
                  if (storeId === undefined || storeId === null) {
                    const addStoreObj = {} as AddStoreRequest;
                    const storeCategorie: StoreCategorie[] = [];
                    arrayCategory.map((item: any) => {
                      let categorie = {} as StoreCategorie;
                      categorie.categoryId = item.categoryId;
                      categorie.settlementPercentage =
                        item.SettlementPercentage;
                      storeCategorie.push(categorie);
                    });
                    addStoreObj.isActive = valueIsActive;
                    addStoreObj.logo = attachmentDocumentLogo!;
                    addStoreObj.banner = attachmentDocumentBanner!;
                    addStoreObj.title = valueTitle!;
                    addStoreObj.settlementDeadlineDays = valueSettlementDeadlineDays!;
                    addStoreObj.settlementPercentage = valueSettlementPercentage!;
                    addStoreObj.sortIndex = valueSortIndex;
                    addStoreObj.description = valueDescription;
                    addStoreObj.storeCategories = storeCategorie;
                    addStoreObj.walletTypeIds = arrayCardList;
                    AddStoreMutate(addStoreObj);
                  } else {
                    const editStoreObj = {} as EditStoreRequest;
                    editStoreObj.storeId = storeId;
                    editStoreObj.title = valueTitle!;
                    editStoreObj.settlementDeadlineDays = valueSettlementDeadlineDays!;
                    editStoreObj.settlementPercentage = valueSettlementPercentage!;
                    editStoreObj.sortIndex = valueSortIndex;
                    editStoreObj.description = valueDescription;
                    editStoreObj.isActive = valueIsActive;
                    editStoreObj.walletTypeIds = arrayCardList;
                    EditStoreMutate(editStoreObj);
                  }
                }}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form
                    onSubmit={handleSubmit}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSubmit();
                      }
                    }}
                    style={{ height: "100%" }}
                  >
                    <Grid
                      container
                      style={{
                        padding: "20px",
                        paddingBottom: "0px",
                        height: "90%",
                        overflow: "auto",
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={8}
                        borderLeft={{ lg: "1px solid #C1C7CB" }}
                        style={{
                          paddingLeft: "60px",
                          // height: "100%",
                          // overflow: " scroll",
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          style={{ minHeight: "16vh" }}
                          maxHeight={{ xl: "16vh" }}
                        >
                          <Grid container style={{ height: "100%" }}>
                            <Grid
                              item
                              xs={6}
                              sm={3}
                              md={3}
                              lg={3}
                              xl={2}
                              style={{ paddingRight: "10px" }}
                            >
                              {attachmentDocumentLogo || documentLogo ? (
                                <LoadDocumentCmp
                                  className="UploadImageCmpLogo"
                                  deleteIcon="true"
                                  margin="-1vh"
                                  data={
                                    attachmentDocumentLogo!
                                      ? attachmentDocumentLogo!
                                      : documentLogo
                                  }
                                  setChildValue={setChildValueLogo}
                                  serviceName={DeleteLogo}
                                  cacheName={undefined}
                                  serviceRequestObj={
                                    storeId !== undefined
                                      ? ({
                                          storeId: storeId,
                                        } as DeleteLogoRequest)
                                      : undefined
                                  }
                                  attachments={attachmentDocumentLogo}
                                  multiItem={false}
                                  picName={"storePic"}
                                  document={documentLogo}
                                />
                              ) : (
                                <ImageEditorCmp
                                  handleImageSubmit={(e: any) =>
                                    handleChoosedImage(e, "logo")
                                  }
                                  fileTitle={"لوگو"}
                                  logo="StorefrontIcon"
                                />
                              )}
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={9}
                              lg={9}
                              xl={10}
                              style={{ paddingRight: "10px" }}
                            >
                              {attachmentDocumentBanner || documentBanner ? (
                                <LoadDocumentCmp
                                  height="100%"
                                  // width="100%"
                                  display="block"
                                  position="absolute"
                                  bottom="10px"
                                  left="10px"
                                  className="UploadImageCmpLogo"
                                  className2="uploadImageBanner"
                                  deleteIcon="true"
                                  data={attachmentDocumentBanner}
                                  setChildValue={setChildValueBaner}
                                  serviceName={DeleteBanner}
                                  cacheName={undefined}
                                  serviceRequestObj={
                                    storeId !== undefined
                                      ? ({
                                          storeId: storeId,
                                        } as DeleteLogoRequest)
                                      : undefined
                                  }
                                  multiItem={false}
                                  picName={"storePic"}
                                  document={documentBanner}
                                />
                              ) : (
                                <ImageEditorCmp
                                  handleImageSubmit={(e: any) =>
                                    handleChoosedImage(e, "baner")
                                  }
                                  fileTitle={"تصویر بنر"}
                                  logo="AddPhotoAlternateOutlinedIcon"
                                />
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          spacing={2}
                          style={{ marginTop: "20px" }}
                        >
                          <Grid item xs={4} sm={6} md={4}>
                            <MaterialTextFieldComponent
                              className="shadowTextField"
                              placeHolder={"نام فروشگاه"}
                              label={"نام فروشگاه"}
                              required={true}
                              value={valueTitle ?? ""}
                              onChange={changeValueTitle}
                              // value={values.title}
                              // onChange={handleChange}
                              name="title"
                              id="title"
                              // onBlur={handleBlur}
                            />
                          </Grid>
                          <Grid item xs={4} sm={6} md={4}>
                            <MaterialTextFieldComponent
                              className="shadowTextField"
                              helperText={""}
                              placeHolder={"سهم تسویه حساب (درصد)"}
                              label={"سهم تسویه حساب (درصد)"}
                              required={true}
                              value={valueSettlementPercentage}
                              onChange={changeValueSettlementPercentage}
                              // value={values.settlementPercentage}
                              // onChange={handleChange}
                              name="settlementPercentage"
                              id="settlementPercentage"
                              onBlur={handleBlur}
                            />
                          </Grid>
                          <Grid item xs={4} sm={6} md={4}>
                            <MaterialTextFieldComponent
                              className="shadowTextField"
                              helperText={""}
                              placeHolder={"مهلت تسویه حساب (روز)"}
                              label={"مهلت تسویه حساب (روز)"}
                              required={true}
                              value={valueSettlementDeadlineDays}
                              onChange={changeValueSettlementDeadlineDays}
                              // value={values.settlementDeadlineDays}
                              // onChange={handleChange}
                              name="settlementDeadlineDays"
                              id="settlementDeadlineDays"
                              onBlur={handleBlur}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          spacing={2}
                          style={{ marginTop: "20px" }}
                        >
                          <Grid item xs={4} sm={6} md={4}>
                            <MaterialTextFieldComponent
                              className="shadowTextField"
                              helperText={""}
                              placeHolder={"ترتیب نمایش"}
                              label={"ترتیب نمایش"}
                              required={false}
                              value={valueSortIndex}
                              onChange={changeValueSortIndex}
                              name="sortIndex"
                              id="sortIndex"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={8}
                            sm={6}
                            md={8}
                            style={{ alignContent: "center" }}
                          >
                            <CustomizeSwitch
                              Label={"وضعیت فروشگاه"}
                              checked={
                                valueIsActive
                                  ? valueIsActive
                                  : values.isActive || false
                              }
                              onChange={(checked: boolean) => {
                                values.isActive = checked;
                                setValueIsActive(checked);
                              }}
                              onlabel={"فعال"}
                              offlabel={"غیرفعال"}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          style={{
                            marginTop: "20px",
                            height: "14vh",
                          }}
                        >
                          <Grid item xs={12} style={{ height: "100%" }}>
                            <MaterialTextFieldComponent
                              className={"shadowAreaTextField"}
                              label={"توضیحات"}
                              required={false}
                              rows={2}
                              value={valueDescription}
                              onChange={changeValuesetDescription}
                              name="description"
                              id="outlined-textarea"
                              multiline
                              sx={{
                                "& .MuiOutlinedInput-root > .MuiInputBase-input ": {
                                  fontSize: 13,
                                  lineHeight: "30px !important",
                                  height: "100% !important",
                                },

                                "& .MuiInputBase-root": {
                                  height: "15vh !important",
                                  alignItems: "start",
                                },
                                "& .MuiOutlinedInput-input": {
                                  padding: "0px !important",
                                },
                              }}
                              placeHolder={"توضیحات"}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          style={{
                            marginTop: "20px",
                            minHeight: "20vh",
                            border: "1px solid #DAE0E4",
                          }}
                          className="secondColor_400_BG"
                        >
                          <Grid
                            container
                            spacing={2}
                            style={{
                              backgroundColor: "#ECEDEF",
                              height: "7.5vh",
                              minHeight: "fit-content",
                              paddingTop: "0px",
                              alignContent: "center",
                              width: "100%",
                              border: "1px solid #9AAFC4",
                              alignItems: "center",
                              margin: "2vh",
                              boxShadow:
                                "0 0px 1px 0 rgba(0, 0, 0, 0), 0 -3px 1px 0 rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6}
                              style={{ paddingTop: "0px", paddingRight: "1vh" }}
                            >
                              <DropdownCmp2
                                onChange={handleSelectedProductGroup}
                                value={valueCategoryId}
                                label={"انتخاب دسته بندی محصول *"}
                                options={itemGroups}
                                name="categoryId"
                                id="categoryId"
                                addCategory={true}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              sm={6}
                              md={6}
                              lg={3}
                              sx={{
                                paddingTop: "8px",
                                paddingRight: {
                                  xs: "4vh",
                                  sm: "4vh",
                                  md: "4vh",
                                  lg: "0px",
                                },
                              }}
                              style={{ paddingTop: "8px" }}
                            >
                              <MaterialTextFieldComponent
                                autoFocus={false}
                                placeHolder={" درصد تسویه"}
                                label={"درصد تسویه"}
                                // required={true}
                                value={
                                  valueCategoriesSettlementPercentage || ""
                                }
                                onChange={
                                  changeValueCategoriesSettlementPercentage
                                }
                                name="categoriesSettlementPercentage"
                                id="categoriesSettlementPercentage"
                                onBlur={handleBlur}
                              />
                            </Grid>
                            <Grid item xs={0} sm={0} md={0} lg={1}>
                              {" "}
                            </Grid>
                            <Grid
                              item
                              md={2}
                              xs={2}
                              sm={2}
                              style={{ paddingTop: "0px", textAlign: "end" }}
                            >
                              <Button
                                onClick={saveCategory}
                                disabled={
                                  valueCategoryId === undefined ||
                                  valueCategoryId === null ||
                                  valueCategoryId === ""
                                }
                                className={`${
                                  valueCategoryId === undefined ||
                                  valueCategoryId === null ||
                                  valueCategoryId === ""
                                    ? "btnForm disabledBtn"
                                    : "btnForm defualtColor_100_BG"
                                }`}
                                style={{ width: "10vh" }}
                              >
                                ثبت
                              </Button>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            style={{ marginBottom: "2vh", marginRight: "2vh" }}
                            spacing={2}
                          >
                            {arrayCategory.map((item: any) => (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                lg={6}
                                xl={3}
                                style={{
                                  marginBottom: "10px",
                                  maxWidth: "100%",
                                }}
                              >
                                <StoreCard
                                  arrayCategory={item}
                                  setChildeValueCategory={
                                    setChildeValueCategory
                                  }
                                  setUpdatePercentage={setUpdatePercentage}
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={4}
                        marginTop={{
                          sm: "30px",
                          xs: "30px",
                          md: "30px",
                          lg: "0px",
                        }}
                      >
                        <span
                          className="defualtColor"
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginRight: "3vh",
                          }}
                        >
                          کیف های مجاز
                        </span>
                        <CheckboxImage
                          walletType={walletType}
                          setArrayCard={setArrayCard}
                          arrayCardList={arrayCardList}
                          setIsCheckedWallet={setIsCheckedWallet}
                        />
                      </Grid>
                    </Grid>
                    <Grid container xs={12} style={{ paddingTop: "3vh" }}>
                      <Grid item xs={0} sm={0} md={0} lg={10} xl={10}></Grid>
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        md={6}
                        lg={1}
                        style={{ textAlign: "end" }}
                      >
                        <Button
                          type="submit"
                          disabled={
                            valueTitle !== undefined &&
                            valueSettlementDeadlineDays !== undefined &&
                            valueSettlementPercentage !== undefined
                              ? false
                              : true
                          }
                          className={
                            valueTitle === undefined ||
                            valueTitle === "" ||
                            valueSettlementDeadlineDays === undefined ||
                            valueSettlementDeadlineDays === "" ||
                            valueSettlementPercentage === undefined ||
                            valueSettlementPercentage === ""
                              ? "btnForm disabledBtn"
                              : "btnForm defualtColor_100_BG"
                          }
                          style={{ width: "10vh", marginLeft: "1vh" }}
                        >
                          ثبت
                        </Button>
                      </Grid>
                      <Grid item xs={6} sm={6} md={6} lg={1}>
                        <Button
                          className="btnForm secondColor_300_BG"
                          style={{
                            width: "12vh",
                            marginLeft: "1vh",
                            textAlign: "left",
                          }}
                          onClick={handleClose}
                        >
                          بازگشت
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </>
          }
          title={"ثبت فروشگاه جدید"}
          setHeight={"100%"}
        ></DivisionCmp>
        {openModal === true ? (
          <ModalCancel
            title={""}
            bgColor={"kamanColor"}
            setValue={deleteImage}
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
